import {ENV_TYPE} from "@/pages/Campaign/utils/enum"
import { h5plusReday } from '@mainto/h5plus'
import _ from 'lodash'
import { isInXhsMP } from "@/util/index";

const isInApp = false
h5plusReday().then((res) => {
  isInApp = res.isInApp()
})

export function isInWxMP() {
  return window.wx
}

export function isInAliMP() {
  return window.my
}

export function isInTtMP() {
  return window.tt
}


export function isInMP() {
  return isInWxMP() || isInAliMP() || isInTtMP()
}


export function envType() {
  if (isInWxMP()) return ENV_TYPE.WX_MP
  if (isInAliMP()) return ENV_TYPE.ALI_MP
  if (isInTtMP()) return ENV_TYPE.TT_MP
  if (isInXhsMP()) return ENV_TYPE.XHS_MP
  if (isInApp) return ENV_TYPE.APP
  return ENV_TYPE.H5
}

/**
 * 删除当前url中指定参数
 * @param names 数组或字符串
 * @returns {string}
 */
export function deleteUrlParam(names) {
  let url = `${location.protocol}//${location.host}${location.pathname}${location.hash}`
  // names可能不存在
  if (url.indexOf(names) > -1) {
    const result = url.split('?')
    const childSplit = _.filter(result[1].split('&'), item => item.indexOf(names) < 0).join('&')
    url = `${result[0]}?${childSplit}`
  }
  return url
}
